import { BaseClass } from '../base-class';
import { BaseRepository } from '@interfaces/base-repository';

export class HolidayGroup extends BaseClass implements BaseRepository {
    name: string;

    constructor()
    constructor(
      name: string)
    constructor(
      name?: string) {
        super();

        this.name = this.trim(name);
    }

    static fromObject(object: HolidayGroup): HolidayGroup {
        return Object.assign(new HolidayGroup(), {
          ...object
        });
    }

    get display(): string {
        return `${this.name}`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.name], value);
    }
}
